import React, { useRef } from "react";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../style.scss";
import * as yup from "yup";
import { useFormik } from "formik";
import PreviewImage from "../../../Component/previewImage";
import { apiAdminConfig } from "../../../utils/api";
import moment from "moment";
import useToast from "../../../provider/Toast/useToast";
import { FilePdfOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import { FileBox } from "../../../Component/form";


const AddApplicant = () => {
  const toast = useToast();
  const navigate = useNavigate();

  const validationSchema = yup.object().shape({
    contact_number: yup.string().required("Contact Number is a required"),
    email: yup.string().required("Email is a required").matches(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/, 'Invalid email'),
    first_name: yup.string().required("First Name is a required"),
    middle_name: yup.string().required("Middle Name is a required"),
    last_name: yup.string().required("Last Name is a required"),
    qualification: yup.string().required("Qualification is a required"),
    speciality: yup.string().required("Speciality is a required"),
    reg_number: yup.string().required("Registration Number is a required"),
    state: yup.string().required("State is a required"),
    dob: yup.string().required("Date of Birth is a required"),
    marriage_date: yup.string().required("Marriage Date is a required"),
    blood_group: yup.string().required("Blood Group is a required"),
    home_address: yup.string().required("Home Address is a required"),
  });

  const { handleSubmit, handleChange, setFieldValue, values, errors, touched } =
    useFormik({
      initialValues: {
        contact_number: "",
        email: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        qualification: "",
        speciality: "",
        reg_number: "",
        state: "",
        dob: "",
        marriage_date: "",
        blood_group: "",
        degree_certificate: "",
        mmc_certificate: "",
        image: null,
        home_address: "",
        life_time_membership_number : "",
      },
      validationSchema,
      onSubmit: async (values) => {
        await apiAdminConfig.post(`admin/doctor/create`, values).then((response) => {
          if (response?.data.status) {
            navigate('/applicant')
            toast({
              message: response?.data?.message,
              bg: 'success'
            });
          } else {
            toast({
              message: response?.data?.message,
              bg: 'danger'
            });
          }
        }).catch((error) => {
          const { response } = error
          toast({
            message: response?.data?.message,
            bg: "danger",
          });
        })
      },
    });



  return (
    <main id="announcements">
      <Container className="admin_padding">
        <div className="admin_add_form">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "14px 0",
              alignItems: "center",
            }}
            className="table-hader-container"
          >
            <div>
              <h3 className="table-hader-name">Add Application</h3>
            </div>
            <Link to="/applicant" className="page_add_btn">
              Back
            </Link>
          </div>
          <Row>
            <Col>
              <Form noValidate onSubmit={handleSubmit}>
                {/* <Row className="mb-3">
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>
                      Title<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      disabled
                      isInvalid={!!errors.title && touched.title}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.title}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row> */}
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        First Name<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="first_name"
                        value={values.first_name}
                        onChange={handleChange}
                        isInvalid={!!errors.first_name && touched.first_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.first_name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Middle Name<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="middle_name"
                        value={values.middle_name}
                        onChange={handleChange}
                        isInvalid={!!errors.middle_name && touched.middle_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.middle_name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Last Name<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="last_name"
                        value={values.last_name}
                        onChange={handleChange}
                        isInvalid={!!errors.last_name && touched.last_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.last_name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Contact Number<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="contact_number"
                        value={values.contact_number}
                        onChange={handleChange}
                        isInvalid={!!errors.contact_number && touched.contact_number}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.contact_number}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Email Id<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="mail"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        isInvalid={!!errors.email && touched.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
               
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Qualification<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="qualification"
                        value={values.qualification}
                        onChange={handleChange}
                        isInvalid={!!errors.qualification && touched.qualification}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.qualification}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Speciality<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="speciality"
                        value={values.speciality}
                        onChange={handleChange}
                        isInvalid={!!errors.speciality && touched.speciality}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.speciality}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                      Life time membership number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="life_time_membership_number"
                        value={values.life_time_membership_number}
                        onChange={handleChange}
                        isInvalid={!!errors.life_time_membership_number && touched.life_time_membership_number}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.life_time_membership_number}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Medical council registration number<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="reg_number"
                        value={values.reg_number}
                        onChange={handleChange}
                        isInvalid={!!errors.reg_number && touched.reg_number}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.reg_number}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        State<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="state"
                        value={values.state}
                        onChange={handleChange}
                        isInvalid={!!errors.state && touched.state}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.state}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        DOB<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={values.dob}
                        onChange={handleChange}
                        isInvalid={!!errors.dob && touched.dob}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.dob}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Marriage anniversary date<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="marriage_date"
                        value={values.marriage_date}
                        onChange={handleChange}
                        isInvalid={!!errors.marriage_date && touched.marriage_date}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.marriage_date}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Blood group<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="blood_group"
                        value={values.blood_group}
                        onChange={handleChange}
                        isInvalid={!!errors.blood_group && touched.blood_group}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.blood_group}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        Home Address<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="home_address"
                        value={values.home_address}
                        onChange={handleChange}
                        isInvalid={!!errors.home_address && touched.home_address}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.home_address}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <Form.Label>
                      Degree certificate
                    </Form.Label>
                    <FileBox 
                     name="degree_certificate"
                     accept = "image/*"
                     error={errors.degree_certificate}
                     value={values.degree_certificate}
                     url="imageUpload/CERTIFICATE"
                      onChange={(e) => setFieldValue("degree_certificate", e)}
                    />
                  </Col>
                  <Col>
                    <Form.Label>
                      MMC certificate
                    </Form.Label>
                    <FileBox
                      onChange={(e) =>{
                        setFieldValue("mmc_certificate", e)
                      }}
                      accept = "image/*"
                      name="mmc_certificate"
                      error={errors.mmc_certificate}
                      value={values.mmc_certificate}
                      url="imageUpload/CERTIFICATE"
                    />
                  </Col>
                  <Col>
                    <Form.Label>
                      Profile pic
                    </Form.Label>
                    {/* <div>
                      {values?.image && (
                        <PreviewImage file={values.image} />
                      )}
                    </div> */}
                    <FileBox
                      onChange={(e) => {
                        setFieldValue("image", e)
                      }}
                      accept = "image/*"
                      name="image"
                      error={errors.image}
                      value={values.image}
                      url="imageUpload/PROFILE"
                    />
                  </Col>
                </Row>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="footer-btns"
                >
                  <Button type="submit" className="input_file_button">
                    Save
                  </Button>
                  {/* <Popconfirm
                    title="Are you sure want to delete ?"
                    onConfirm={() => onDelete()}
                  >
                    <Button className="input_file_button">
                      Delete
                    </Button>
                  </Popconfirm> */}
                  {/* <Button onClick={() => setApproved("APPROVED", id)} className="input_file_button">
                    Approve
                  </Button>
                  <Button onClick={() => setApproved("REJECTED", id)} className="input_file_button">Reject</Button> */}
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </main>
  );
};

export default AddApplicant;
